import { BaseEntity } from "../baseEntity";
export class BandScaleTableResponse extends BaseEntity {
}
